import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DeletePopup from "../GardenPopup/DeletePopup"
import ContractorNamePopup from "./ContractorNamePopup"
import { ContractorNameDDL } from "../../../../Components/CommonDDL/ContractorNameDDL"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { ContractorNameDeleteAPI, ContractorNameExportTableDataAPI, ContractorNameTableDataAPI } from "../../../../Redux/SidebarMasterSlice/ContractorNameSlice"
import { Loading } from "../../../../Helper/Loading"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { useSearchParams } from "react-router-dom"
import { ProjectTypeDataDDL } from "../../../../Components/CommonDDL/ProjectTypeDataDDL"
import { ContractorNameExportData } from "./ContractorNameExportData"
import { ElEProjectNameDDL } from "../../../../Components/CommonDDL/ElEProjectNameDDL"
import { MasterContractorNameDDL } from "../../../../Components/CommonDDL/MasterContractorNameDDL"

export const ContractorName = () => {

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [DepartmentPopupShow, setDepartmentPopupShow] = useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [Flag, setFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [ContractorNamePopupShow, setContractorNamePopupShow] = useState()

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setContractorNamePopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setContractorNamePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setContractorNamePopupShow(false)
    }

    const [ContractorName, setContractorName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Department, setDepartment] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleDeleteOnClick = () => {
        setDeletePopupShow(true)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [ContractorName.ID])

    const handleDeleteApi = (item) => {
        const data = {
            M_ContractorID: item.m_ContractorID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(ContractorNameDeleteAPI({ data }))
    }
    // const { isDeleteLoading } = useSelector(state => state.DepDeleteData)


    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setContractorName({
            ...ContractorName,
            ID: 0,
            Label: 'Select...'
        })
        // setProjectType({
        //     ...ProjectType,
        //     ID: 0,
        //     Label: 'Select...'
        // })
    }

    useEffect(() => {
        const data = {
            M_ContractorID: ContractorName.ID,
            M_ProjectTypeID: ProjectType.ID,
            ContractorName: '',
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
            handleContractorNameExport: handleContractorNameExport
        }
        if (ProjectType?.ID != 0) {
            dispatch(ContractorNameTableDataAPI({ data }))
        }
    }, [IsPost, To, IsClear, isSearch, ProjectType.ID])

    const { tableData, isLoading } = useSelector(state => state.ContractorNameTableData)

    const handleContractorNameExport = () => {
        const data = {
            M_ContractorID: ContractorName.ID,
            M_ProjectTypeID: ProjectType.ID,
            ContractorName: '',
            M_UsersID: UserID,
            token: token,
            From: '1',
            To: '99999',
        }
        if (ProjectType?.ID != 0) {
            dispatch(ContractorNameExportTableDataAPI({ data }))
        }
    }
    // , [IsPost, IsClear, isSearch])

    const { ExportTableData, isExportLoading } = useSelector(state => state.ContractorNameExportTableData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }
    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active='contractorname' listActive="masters" />
                    <div id="" className="content1">
                        <div className="data_mob1">
                            <div className="row  m-1 py-1 pb-4 master_border">
                                <div className="col-12 d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="m-0 ps-1 py-1">Contractor Name Master</h5>

                                    <span style={{ fontSize: "16px", color: "gray", fontWeight: "bold" }}>
                                        Total Count: {tableData && tableData.table && tableData.table.length > 0 ? tableData.table[0].totalCount : 0}
                                    </span>

                                    <div className="d-flex align-items-center">
                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary mx-2" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <span className="mx-2">
                                                    <ContractorNameExportData
                                                        ExcelData={ExportTableData}
                                                        name='Contractor Name Master'
                                                    />
                                                </span>
                                        }
                                        <i className="fa-solid fa-plus btn btn-secondary"
                                            style={{ color: "white" }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12 ">

                                            <div className="row rounded2 d-flex align-items-end">
                                                <div className="col-lg-3 col-md-6">
                                                    {/* <ElEProjectNameDDL
                                                        ProjectName={ProjectType}
                                                        setProjectName={setProjectName}
                                                        M_ProjectTypeID={ProjectTypeId}
                                                    /> */}
                                                    <ProjectTypeDataDDL
                                                        ProjectType={ProjectType}
                                                        setProjectType={setProjectType}
                                                        Flag={Flag}
                                                        rowData={rowData}
                                                        M_ProjectTypeID={M_ProjectTypeID}
                                                    />

                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3 ">
                                                    <MasterContractorNameDDL
                                                        ContractorName={ContractorName}
                                                        setContractorName={setContractorName}
                                                        M_ProjectTypeID={ProjectType?.ID}
                                                        M_ProjectID='0'
                                                        M_ContractorID='0'
                                                        IsPost={IsPost}
                                                        APIFlag="ProjectType_Wise_Contractor  "
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3 col-lg-3 mt-md-4 d-md-flex" >
                                                    <div className="d-flex" style={{ marginTop: "-3em" }}>
                                                        <button type="button"
                                                            className="btn-clear btn btn-primary mx-2"
                                                            onClick={handleSearch}
                                                        >
                                                            Search</button>
                                                        <button type="button"
                                                            className="btn btn-outline-danger"
                                                            onClick={handleClear}
                                                        >
                                                            Clear</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Project Type</th>
                                                            <th>Contractor Name</th>
                                                            {/* <th>Ward Name</th> */}
                                                            <th>Ward Name</th>
                                                            <th>Contact Person Name</th>
                                                            <th>Mobile Number</th>
                                                            <th>Email Id</th>
                                                            <th className="action-col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td className="sr-no-col" style={{ textAlign: "center" }}>{item.rowNum}</td>
                                                                    <td className="min-w-110">{item.projectType ? item.projectType : '-'}</td>
                                                                    <td>{item.contractorName ? item.contractorName : '-'}</td>
                                                                    {/* <td>{item.wardName ? item.wardName : '-'}</td> */}
                                                                    <td>{item.address ? item.address : '-'}</td>
                                                                    <td>{item.contactPersonName ? item.contactPersonName : '-'}</td>
                                                                    <td>{item.mobileNo ? item.mobileNo : '-'}</td>
                                                                    <td>{item.emailID ? item.emailID : '-'}</td>

                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        {/* <ContractorNamePopup
                                                                            open={ContractorNamePopupShow}
                                                                            handleIsPost={handleIsPost}
                                                                            item={item}
                                                                            Flag='Update'
                                                                        /> */}
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <></>
                                                        }
                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    ContractorNamePopupShow ?
                        <ContractorNamePopup
                            open={ContractorNamePopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </>
    )
}